import { localGetStorage } from '@/lib/storage';
import { Box, Button, Container, Stack } from '@mui/material';

type sendBtnProps = {
  setIsSubmit: (value: boolean) => void;
  setTypeLogin: (value: string) => void;
};
export default function SendBtn(aPayload: sendBtnProps) {
  const { setIsSubmit, setTypeLogin } = aPayload;
  return (
    <Box position="relative" bottom={0} left={0} width="100%">
      <Container maxWidth="sm">
        <Stack direction="row" gap={1} mb={3}>
          <Button
            variant="contained"
            size="large"
            fullWidth
            type="submit"
            onClick={() => {
              const re = localGetStorage('snsAddress') || false;
              setTypeLogin(re.typeOfLogin);
              setIsSubmit(true);
            }}
          >
            보내기
          </Button>
        </Stack>
      </Container>
    </Box>
  );
}
